export const BAND_STYLES = {
  hot: { label: "Hot Opportunity", ring: "text-emerald-500", chip: "bg-emerald-500/10 text-emerald-600" },
  strong: { label: "Strong Lead", ring: "text-blue-500", chip: "bg-blue-500/10 text-blue-600" },
  explore: { label: "Worth Exploring", ring: "text-amber-500", chip: "bg-amber-500/10 text-amber-600" },
  low: { label: "Low Priority", ring: "text-muted-foreground", chip: "bg-secondary text-muted-foreground" },
};

export const LeadScoreBadge = ({ score, band, size = 48 }) => {
  const s = BAND_STYLES[band] || BAND_STYLES.low;
  const r = (size - 8) / 2;
  const c = 2 * Math.PI * r;
  return (
    <div className="flex flex-col items-center gap-1" data-testid="lead-score-badge">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth="4" className="stroke-secondary" />
          <circle
            cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth="4"
            strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * score) / 100}
            className={`${s.ring} stroke-current transition-all`}
          />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center font-display text-sm font-semibold">
          {score}
        </span>
      </div>
    </div>
  );
};
